import {
    Row, Col, Skeleton, Button, App, 
} from 'antd';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useOutletContext, useSearchParams, useNavigate } from 'react-router-dom';
import CurrentEventPanel from '../CurrentEventPanel';
import AlertsPanel from '../AlertsPanel';
import CaptureOdoPanel from '../../../components/panels/CaptureOdoReadingPanel'
import SubmitTravelRequestPanel from '../../../components/panels/SubmitTravelRequestPanel'
import ManageIncidentsPanel from '../../../components/panels/ManageIncidentsPanel';
import {getSessionData, storeSessionData} from '../../../utility/global-util';
import ManageMaintenancePanel from '../../../components/panels/ManageMaintenancePanel';
import {getDriverRouteById} from "../../../components/routes/driverRoutes";
import {imageLocations} from "../../../components/image/ImageLocations";
import PanelFrameWithImage from "../../../components/panels/PanelFrameWithImage";
import '../Home.css';
import useOnlineStatus from "../../../utility/hooks/useOnlineStatus";
import AdditionalLinksPanel from '../../../components/panels/AdditionalLinksPanel';
import ManageTyresPanel from '../../../components/panels/ManageTyresPanel';
import QuotesPanel from '../../../components/panels/QuotesPanel';
import CreateQuotePanel from '../../../components/panels/CreateQuotePanel';
import { getQuotes } from '../../../api/quotes';
import { showApiError } from "../../../utility/error/error-handler";


    const Default = ( ) => {

    const { t } = useTranslation();
    const { notification } = App.useApp();
    const { isOnline } = useOnlineStatus();

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const context = useOutletContext();
    const vehicle = context.vehicle;
    const permissions = context.permissions;
    const refreshPage = context.refreshPage;
    const setRefreshPage = context.setRefreshPage;

    const [ loadingProgress, setLoadingProgress ] = useState(0);  //start 0 - button shows loading if less than 100

    let refreshPageDefault = false;
    if (getSessionData("refreshPage"))
    {
        refreshPageDefault = true;
        storeSessionData("refreshPage", null);
    }

    setRefreshPage(refreshPageDefault);

    if (refreshPage)
    {
        storeSessionData('incidentData', null)
    }

    // Handle no allocated contracts
    const [dummyMode, setDummyMode] = useState(false);
    const allocContracts = getSessionData("driverHasAllocContracts"); //comes back as string
    useEffect(() => {
        setDummyMode(allocContracts ? allocContracts === 'false': false);
    }, [allocContracts, setDummyMode]);
    const DummyButton = ({label}) => {
        return (
            label
            ? <Button className="dp-dummy-button">{label}</Button>
            : <></>
        );
    }
    const DummyPanel = ({title, imageLocation, buttonLabel}) => {
        return (
            <PanelFrameWithImage title={title}
                                 imageLocation={imageLocation}
                                 height="260px"
                                 buttons={<DummyButton label={buttonLabel} />}
            >
                <Skeleton active={false} title={false} paragraph={{ rows: buttonLabel ? 4 : 5 }} />
            </PanelFrameWithImage>
        );
    }

    // MOT Notification Action
    const [maintRequestsModalVisible, setMaintRequestsModalVisible] = useState(false);
    const [motPreselected, setMotPreselected] = useState(false);
    useEffect(() => {
        const readToken = searchParams ? searchParams.get("action") : null;
        if (readToken && readToken === 'MOT') {
            setMotPreselected(true);
            setMaintRequestsModalVisible(true);
            navigate(getDriverRouteById('home'));
        }
    }, [searchParams, navigate]);

    const userCustomer = getSessionData('selectedCustomer');
    let userCustomerAccount = '';
    let userCustomerEntity = '';
    if (userCustomer) {
        userCustomerAccount = userCustomer.code ? userCustomer.code : '';
        userCustomerEntity = userCustomer.entityId ? userCustomer.entityId : '';
    }
    // Included the getQuotes here to facilitate, user creating a new quote within Apex and then refreshing driver portal
    const [ driverQuotes, setDriverQuotes] = useState(getSessionData("driverQuotes"));
    useEffect(() => {
      if (isOnline) {
        if (userCustomerEntity && userCustomerAccount) {
          getQuotes(userCustomerEntity, 'C', userCustomerAccount, setLoadingProgress)
              .then(res => {
                storeSessionData('driverQuotes', null);
                storeSessionData('driverQuotes', res);
                setDriverQuotes(res);
              },)
              .catch(err => {
                  // Show error if online otherwise show dash if offline (not been on this vehicle or cache not working)
                  showApiError('', err, notification);
              });
        }
      } 
    }, [t, notification, userCustomerEntity, userCustomerAccount, isOnline, refreshPage, setRefreshPage]);  

    // Handle position of the quotes panel depending on whether driver quotes exists or not
    const driverHasQuotes = driverQuotes && driverQuotes.length > 0;

    return (
      <div>
        <Row justify="space-between">
            {/* Driver Quotes  */}
            {
                !allocContracts && driverQuotes && driverQuotes.length > 0
                ?
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <QuotesPanel driverQuotes={driverQuotes}
                                 permissions={permissions}
                                 refreshPage={refreshPage}
                                 setRefreshPage={setRefreshPage}
                                 loadingProgress={loadingProgress}
                                 setLoadingProgress={setLoadingProgress}
                    /> 
                </Col>                
                :
                (<></>)
            }

            {/* Vehicle Warnings and Current Events (not displayed offline) */}
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                { dummyMode || !isOnline
                  ? <></>
                  : <>
                      <AlertsPanel vehicle={vehicle} refreshPage={refreshPage} setRefreshPage={setRefreshPage} /> 
                      <CurrentEventPanel vehicle={vehicle} refreshPage={refreshPage} setRefreshPage={setRefreshPage} setPageLoading={context.setPageLoading} />
                    </>
                }
            </Col>

            {/* Driver Quotes  */}
            {
                allocContracts && driverQuotes && driverQuotes.length > 0
                ?
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <QuotesPanel driverQuotes={driverQuotes}
                                 permissions={permissions}
                                 refreshPage={refreshPage}
                                 setRefreshPage={setRefreshPage}
                                 loadingProgress={loadingProgress}
                                 setLoadingProgress={setLoadingProgress}
                    /> 
                </Col>                
                :
                (<></>)

            }
            
            {/* Maintenance (ensure all data load GETs needed by the panel are included above for offline caching) */}
            {
                permissions.includes("DRIVERS_PORTAL_MAINTENANCE_VIEW")  
                ? 
                (
                    <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                        { 
                        dummyMode
                        ? <DummyPanel title={t('title.maintenance_and_servicing')}
                                imageLocation={imageLocations.MAINTENANCE_AND_SERVICING_IMAGE}
                                buttonLabel={t('title.booking_requests')}
                                />
                        : <ManageMaintenancePanel vehicle={vehicle}
                                            refreshPage={refreshPage}
                                            setRefreshPage={setRefreshPage}
                                            maintRequestsModalVisible={maintRequestsModalVisible}
                                            setMaintRequestsModalVisible={setMaintRequestsModalVisible}
                                            motPreselected={motPreselected}
                                            setMotPreselected={setMotPreselected}
                                            /> 
                        }
                    </Col>
                )
                : 
                (<></>)
            } 

            {/* Tyres (ensure all data load GETs needed by the panel are included above for offline caching) */}
            {
                permissions.includes("DRIVERS_PORTAL_MAINTENANCE_VIEW")  
                ? 
                (
                    <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                        { 
                        dummyMode
                        ? <DummyPanel title={t('title.tyre_replacements')}
                                imageLocation={imageLocations.TYRE_REPLACEMENT_IMAGE}
                                buttonLabel={t('title.tyre_request')}
                                />
                        : <ManageTyresPanel vehicle={vehicle}
                                            /> 
                        }
                    </Col>
                )
                : 
                (<></>)
            }             
                         

            {/* Incidents (ensure all data load GETs needed by the panel are included above for offline caching) */}
            {permissions.includes("DRIVERS_PORTAL_INCIDENT_MANAGEMENT")  ? (
            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                { dummyMode
                    ? <DummyPanel title={t('title.manage_incidents')}
                                  imageLocation={imageLocations.INCIDENT}
                                  buttonLabel={t('action.report_incident')}
                      />
                    : <ManageIncidentsPanel vehicle={vehicle}
                                            refreshPage={refreshPage}
                                            setRefreshPage={setRefreshPage}
                      /> }
            </Col>
            ): (<></>)}

            {/* ODO Reading (ensure all data load GETs needed by the panel are included above for offline caching) */}
            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                { dummyMode
                    ? <DummyPanel title={t('title.submit_odo_reading')}
                                  imageLocation={imageLocations.ODOMETER_IMAGE}
                                  buttonLabel={t('action.submit')}
                      />
                    : <CaptureOdoPanel vehicle={vehicle}
                                       refreshPage={refreshPage}
                                       setRefreshPage={setRefreshPage}
                      /> }
            </Col>

            {/* Travel Requests (ensure all data load GETs needed by the panel are included above for offline caching) */}
            {permissions.includes("DRIVERS_PORTAL_MY_ACTIONS") ? (
            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                { dummyMode
                    ? <DummyPanel title={t('title.my_travel_requests')}
                                  imageLocation={imageLocations.TRAVEL_IMAGE}
                                  buttonLabel={t('title.new_travel_request')}
                      />
                    : <SubmitTravelRequestPanel vehicle={vehicle}
                                                refreshPage={refreshPage}
                                                setRefreshPage={setRefreshPage}
                      /> }
            </Col>
            ): (<></>)}

           {/* Quotes - to show a new panel to allow a driver to create a quote within the Apex application. Once a quote exists, this panel will disappear */}
           {
                permissions.includes("QUOTES") && !driverHasQuotes
                ? 
                (
                    <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                        <CreateQuotePanel loadingProgress={loadingProgress}
                                          setLoadingProgress={setLoadingProgress}
                        /> 
                    </Col>
                )
                : 
                (<></>)
            } 

           <Col xs={24} sm={24} md={24} lg={24} xl={12}>
               { dummyMode
               ? <DummyPanel title={t('title.driver_information')} />
               : <AdditionalLinksPanel refreshPage={refreshPage}
                                       setRefreshPage={setRefreshPage}
                /> }
            </Col>
            

            {/* Intentionally added below code to facilitate showing the SubmitOrViewMaintenanceRequests modal  
                when the driver selects the MOT notification and the driver in question does not have the DRIVERS_PORTAL_MAINTENANCE_VIEW role 
                Ensure any tiles that may be visible are put before this one */}
            {
            !permissions.includes("DRIVERS_PORTAL_MAINTENANCE_VIEW") && permissions.includes("DRIVERS_PORTAL_MY_ACTIONS")  
            ? 
            (
                <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                    { 
                    dummyMode
                    ? 
                      <></>
                    : <ManageMaintenancePanel vehicle={vehicle}
                                            refreshPage={refreshPage}
                                            setRefreshPage={setRefreshPage}
                                            maintRequestsModalVisible={maintRequestsModalVisible}
                                            setMaintRequestsModalVisible={setMaintRequestsModalVisible}
                                            motPreselected={motPreselected}
                                            setMotPreselected={setMotPreselected}
                                            /> 
                    }
                </Col>
            )
            : 
            (<></>)
           }
        </Row>
      </div>
    );
}

export default Default;